// extracted by mini-css-extract-plugin
export default {"anchor":"t9_nH"};